import { __assign } from "tslib";
import * as React from 'react';
import { TravellerFields } from '@websky/core/src/TravellerForm/types';
import TravellerComponent from '@websky/core/src/Traveller/components/Traveller';
import * as css from './Traveller.css';
var Traveller = function (props) {
    var _a, _b;
    var fieldValueByName = function (fieldName) {
        return props.traveller.values.find(function (field) { return field.name === fieldName; }).value;
    };
    var firstName = ((_a = fieldValueByName(TravellerFields.FirstName)) === null || _a === void 0 ? void 0 : _a[0]) || '';
    var lastName = ((_b = fieldValueByName(TravellerFields.LastName)) === null || _b === void 0 ? void 0 : _b[0]) || '';
    return (React.createElement(TravellerComponent, __assign({}, props, { addElement: React.createElement("div", { className: css.add_element }), personElement: React.createElement("div", { className: css.person_element },
            firstName,
            lastName) })));
};
export default Traveller;
